import React, {useContext} from "react";
import Context from "../../context/Message";

export default ({filter, setFilter}) => {
    const {$locale, filters} = useContext(Context);

    if (filters?.length < 2) {
        return null;
    }

    return (
        <ul className="message-filter-select">
            {filters.map(key => (
                <li
                    key={key}
                    onClick={() => setFilter(key)}
                    className={filter === key ? 'active' : ''}
                >{$locale.get(`comment.streamFilter.${key}`)}</li>
            ))}
        </ul>
    );
};
